import { ReactElement, useState } from 'react'
import { InputBase } from '@mui/material'

/** Documents and plans store their name as the tree item's `node_name` (VARCHAR(255)). */
const FILE_NAME_MAX_LENGTH = 255

export interface FileListTitleInputProps {
  /** Name the draft starts from; the input is mounted fresh for every edit. */
  initialName: string
  onCommit: (draftName: string) => void
  onCancel: () => void
}

/** Inline name input of an `EditableFileListTitle`: Enter/blur commits, Escape cancels. */
export const FileListTitleInput = ({
  initialName,
  onCommit,
  onCancel,
}: FileListTitleInputProps): ReactElement => {
  const [draftName, setDraftName] = useState(initialName)

  return (
    <InputBase
      autoFocus
      fullWidth
      value={draftName}
      onChange={event => setDraftName(event.target.value)}
      onClick={event => event.stopPropagation()}
      onBlur={() => onCommit(draftName)}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          event.preventDefault()
          onCommit(draftName)
        } else if (event.key === 'Escape') {
          event.preventDefault()
          onCancel()
        }
      }}
      inputProps={{
        maxLength: FILE_NAME_MAX_LENGTH,
        style: {
          padding: 0,
          height: '19px',
          lineHeight: '19px',
          boxSizing: 'border-box',
        },
      }}
      sx={{
        fontSize: 13,
        height: '19px',
        color: 'text.primary',
        p: 0,
      }}
    />
  )
}
